const sectionID = document.querySelector('.product__main').id.replace('shopify-section-', '')
let variantSelectors = document.querySelectorAll('.variant-option')

const changeProductEvent = new Event("changeProduct");

const changeProduct = (productURL) => {
  let requestURL = `${
    window.location.origin
  }${productURL}?section_id=${sectionID}`
  fetch(requestURL).then(response => response.text()).then((responseText) => {
    const newHtml = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.js-product_section').innerHTML;

    document.querySelector('.js-product_section').innerHTML = newHtml;
    history.pushState({}, '', `${productURL}`)
    document.dispatchEvent(changeProductEvent)
  })
};

variantSelectors.forEach((selector) => {
  selector.addEventListener('click', (e) => {
    let productURL = e.currentTarget.dataset.href
    changeProduct(productURL)
  })
})

document.addEventListener("changeProduct", (e) => {
  console.log('changing product')
  const variantSelectors = document.querySelectorAll('.variant-option')
  variantSelectors.forEach((selector) => {
    selector.addEventListener('click', (e) => {
      let productURL = e.currentTarget.dataset.href
      changeProduct(productURL)
    })
  })

  Shopify.theme.jsProduct.init(window.Shopify.productObject)
  Shopify.contentCreator.accordion.init()
  Shopify.initProductReviews();
  // handleProductInventory();  
  pullVariantInventory();
}, false,);

const pullVariantInventory = async () => {
  
  // let productURL = window.origin + window.location.pathname + ".js"
  // fetch(productURL)
  // .then(response => response.json())
  // .then(async data => {
  //   await data.variants.forEach(async ({id}) => {
  //     let thisVariantInventory = await getVariantInventory(id);
  //     allVariantsInventory[id] = thisVariantInventory;
  //     console.log('assigning variants')
  //   })
  //   console.log('running this line')
  // })
  // .then(() => {
  //   handleProductInventory()
  // });

    handleProductInventory()
  
}

const handleProductInventory = async () => {
  let varID = document.querySelector('#product-variant').dataset.id
  let ukOrEu;
  if (window.location.href.includes('eu')) {
    ukOrEu = 'EU'
  } else {
    ukOrEu = 'UK'
  }

  let currentVariantInventory = await getVariantInventory(varID);

  console.log(currentVariantInventory)
  
  const showATC = () => {
    document.querySelector('#shopify-section-product__main .purchase-details').style.display = 'flex'
    if (document.querySelector('#oos-notification')) {
      document.querySelector('#oos-notification').style.display = 'none'
    }
  }

  const hideATC = () => {
    document.querySelector('#shopify-section-product__main .purchase-details').style.display = 'none'
    if (document.querySelector('#oos-notification')) {
      document.querySelector('#oos-notification').style.display = 'block'
    }
  }

  const handleStock = (stock) => {
    //dont apply inventory to gift cards
    if (stock === 0) {
      hideATC()
    } else {
      showATC()
    }
  }
  
  if (currentVariantInventory.locations.length === 2) {
    currentVariantInventory.locations.forEach(({ name, stock}) => {
      if (name === 'United Kingdom' && ukOrEu === 'UK') {
        handleStock(stock);
      } else if (name === 'Ireland' && ukOrEu === 'EU') {
        handleStock(stock);
      }
      
    })
  } else if (currentVariantInventory.locations.length === 1) {
    currentVariantInventory.locations.forEach(({ name, stock}) => {
    if (name === 'United Kingdom' && ukOrEu === 'UK') {
      handleStock(stock)
    } else if (name === 'Ireland' && ukOrEu === 'EU') {
      handleStock(stock)
    } else {
      hideATC()
    }
  })
  }
  
}


onpopstate = (event) => {
  const origin = event.currentTarget.location.origin
  const path = event.currentTarget.location.pathname
  let requestURL = `${
    origin
  }${path}?section_id=${sectionID}`
  fetch(requestURL).then(response => response.text()).then((responseText) => {
    const newHtml = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.js-product_section').innerHTML;

    document.querySelector('.js-product_section').innerHTML = newHtml;
  }).then(() => {
    document.dispatchEvent(changeProductEvent)
  });
};